import _taggedTemplateLiteral from "/builds/schumacherweb/devbridge/scp-web-client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  /* blurriness fixes */\n  path {\n    transform: scale(1.0669) translate3d(-1px, -1px, 0);\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import { __rest } from "tslib";
import React, { useEffect, useRef } from 'react';
import styled from 'styled-components';
import { Icon } from '@scp/ui-shared/theme/icons';
import { color } from '@scp/ui-shared/theme/variables';
import { SwitchInputBase } from './SwitchInputBase';
export var CHECKBOX_SIZE = 20;
var CheckIcon = styled(Icon)(_templateObject());

function getIconColor(_ref) {
  var checked = _ref.checked,
      invalid = _ref.invalid;

  if (invalid) {
    return color.invalid;
  }

  if (checked) {
    return color.action;
  }

  return undefined;
}

export var Checkbox = function Checkbox(_a) {
  var indeterminate = _a.indeterminate,
      props = __rest(_a, ["indeterminate"]);

  var checkboxRef = useRef(null);
  useEffect(function () {
    if (checkboxRef.current) {
      checkboxRef.current.indeterminate = !!indeterminate;
    }
  }, [indeterminate]);
  return React.createElement(SwitchInputBase, Object.assign({}, props, {
    inputRef: checkboxRef,
    checkedIcon: React.createElement(CheckIcon, {
      name: "check-box",
      color: getIconColor({
        checked: true,
        invalid: props.invalid
      })
    }),
    uncheckedIcon: React.createElement(CheckIcon, {
      name: "check-box-outline-blank",
      color: getIconColor({
        invalid: props.invalid
      })
    }),
    indeterminateIcon: React.createElement(CheckIcon, {
      name: "indeterminate-check-box",
      color: color.action
    }),
    type: "checkbox",
    size: CHECKBOX_SIZE
  }));
};